<div class="card-select-grid" [class]="columnsClass" [class.compact]="compact" data-testid="card-select-grid">
  @for (opt of selectOptions; track opt[valueKey]) {
  <button type="button" class="card-select-option" [class.selected]="isSelected(opt)" [class.compact]="compact" [disabled]="formControl.disabled"
    (click)="onSelect(opt)" [attr.data-testid]="'card-option-' + opt[valueKey]">
    @if (cardTemplate) {
    <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: opt, selected: isSelected(opt) }" />
    } @else {
    <span>{{ opt['label'] ?? opt[valueKey] }}</span>
    }
  </button>
  }
</div>